<template>
  <button
    type="button"
    class="btn btn-muffled c-rounded-pill border-0 text-white"
    :class="addClass"
    :aria-expanded="ariaExpanded || undefined"
    :aria-controls="ariaControls"
    :aria-labelledby="ariaLabelledby"
    :aria-label="ariaLabelledby"
  >
    <i
      class="mi-minus scale-140 relative"
      :class="`icon-${iconSize}px`"
    />
  </button>
</template>

<script setup lang="ts">
defineProps({
  iconSize: {
    type: String,
    default: '16',
  },

  addClass: {
    type: String,
    default: '',
  },

  ariaExpanded: {
    type: Boolean,
  },

  ariaControls: {
    type: String,
    default: '',
  },

  ariaLabelledby: {
    type: String,
    default: 'Button minus',
  },
})
</script>
